import React from 'react';
import PropTypes from 'prop-types';

import { useQuickStartStatus } from '../hooks';
import { sections } from '../quickStartSections';
import { testIdPrefix } from '../constants';
import QuickStartActionCard from '../QuickStartActionCard';

import styles from './QuickStartContent.module.scss';

export default function QuickStartContent({
  classes,
  onQuickStartActionClick,
}) {
  const { completed, isLoading } = useQuickStartStatus();

  return (
    <div className={styles.outer} data-testid={`${testIdPrefix}__content`}>
      <div className={styles.inner}>
        {sections.map(section => (
          <QuickStartActionCard
            key={section.sectionId}
            className={classes?.card}
            completed={completed}
            isLoading={isLoading}
            section={section}
            onQuickStartActionClick={onQuickStartActionClick}
            testIdPrefix={testIdPrefix}
          />
        ))}
      </div>
    </div>
  );
}

QuickStartContent.displayName = 'QuickStartContent';
QuickStartContent.propTypes = {
  classes: PropTypes.shape({
    card: PropTypes.string,
  }),
  onQuickStartActionClick: PropTypes.func.isRequired,
};
QuickStartContent.defaultProps = {
  classes: null,
};
